import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { cardOptions, getCardOptions } from 'src/old-pages/booking/confirm/confirm-card-options';

declare const Stripe;
@Injectable()
export class StripeProvider {
  stripe: any;
  elements: any;

  constructor() {
    // Stripe.js loads asynchronously; calling Stripe() here throws ReferenceError
    // before the script tag finishes loading. Initialize lazily on first use instead.
  }

  initialize() {
    if (this.stripe) { return; }
    if (typeof Stripe === 'undefined') { return; }
    this.stripe = Stripe(environment.stripe_key);
    this.elements = this.stripe.elements();
  }

  async ensureLoaded(timeoutMs = 5000): Promise<boolean> {
    if (this.elements) { return true; }
    const start = Date.now();
    while (typeof Stripe === 'undefined' && Date.now() - start < timeoutMs) {
      await new Promise((r) => setTimeout(r, 100));
    }
    this.initialize();
    return !!this.elements;
  }

  getStripe() {
    this.initialize();
    return this.stripe;
  }

  getInstance() {
    this.initialize();
    return this.stripe;
  }

  getElements() {
    this.initialize();
    return this.elements;
  }

  destroyCard() {
    this.initialize();
    const existingCardEl = this.elements?.getElement('card');
    if (existingCardEl && !existingCardEl._destroyed) {
      existingCardEl.destroy();
    }
  }

  getCardElement(isLightMode?: boolean) {
    this.initialize();
    this.destroyCard();
    if (!this.elements) { return null; }
    return this.elements.create('card', isLightMode ? getCardOptions(true) : cardOptions);
  }

  collectBankAccountForSetup(payload: { name: string; client_secret: string }) {
    this.initialize();
    return this.stripe.collectBankAccountForSetup({
      clientSecret: payload.client_secret,
      params: {
        payment_method_type: 'us_bank_account',
        payment_method_data: {
          billing_details: { name: payload.name },
        },
      },
    });
  }

  collectFinancialConnectionsAccounts(clientSecret: string) {
    this.initialize();
    return this.stripe.collectFinancialConnectionsAccounts({ clientSecret });
  }
}
